import { useState } from 'react'
import { Modal } from '../components/Modal'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { updateProject } from '../api/projects'
import styles from './GeocoordinatesModal.module.css'

interface GeocoordinatesModalProps {
  projectId: string
  onClose: () => void
  onSaved: () => void
}

export function GeocoordinatesModal({ projectId, onClose, onSaved }: GeocoordinatesModalProps) {
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [latError, setLatError] = useState('')
  const [lonError, setLonError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [apiError, setApiError] = useState('')

  function validateLat(val: string): boolean {
    const n = parseFloat(val)
    if (isNaN(n) || n < -90 || n > 90) {
      setLatError('La latitud debe ser un número entre -90 y 90')
      return false
    }
    setLatError('')
    return true
  }

  function validateLon(val: string): boolean {
    const n = parseFloat(val)
    if (isNaN(n) || n < -180 || n > 180) {
      setLonError('La longitud debe ser un número entre -180 y 180')
      return false
    }
    setLonError('')
    return true
  }

  async function handleSave() {
    const latOk = validateLat(latitude)
    const lonOk = validateLon(longitude)
    if (!latOk || !lonOk) return
    setIsLoading(true)
    setApiError('')
    try {
      await updateProject(projectId, {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      })
      onSaved()
    } catch {
      setApiError('Error al guardar las coordenadas. Intenta de nuevo.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal isOpen onClose={onClose} title="Coordenadas geográficas">
      <div className={styles.container}>
        <Input
          label="Latitud"
          type="text"
          placeholder="-41.469300"
          value={latitude}
          onChange={e => setLatitude(e.target.value)}
          error={latError}
        />
        <p className={styles.hint}>Ej: -41.469300 (sur es negativo en Chile)</p>

        <Input
          label="Longitud"
          type="text"
          placeholder="-72.942400"
          value={longitude}
          onChange={e => setLongitude(e.target.value)}
          error={lonError}
        />
        <p className={styles.hint}>Ej: -72.942400 (oeste es negativo en Chile)</p>

        <div className={styles.help}>
          <p>💡 Cómo obtener tus coordenadas:</p>
          <ol>
            <li>Abre Google Maps en tu teléfono</li>
            <li>Busca la dirección del proyecto</li>
            <li>Mantén presionado el pin rojo</li>
            <li>Copia los números que aparecen (ej: -41.469300, -72.942400)</li>
          </ol>
        </div>

        {apiError && <p className={styles.apiError}>{apiError}</p>}

        <Button variant="primary" loading={isLoading} onClick={handleSave}>
          Guardar coordenadas
        </Button>
      </div>
    </Modal>
  )
}
